import { AwardWinner } from 'components/award/award-winner/AwardWinner'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { BrandWinnerContainer } from './brand-winner/BrandWinnerContainer'
import { CategoryWinnerContainer } from './category-winner/CategoryWinnerContainer'
import { GeneralAwardWinnerContainer } from './general/GeneralAwardWinnerContainer'

const AWARD_WINNER_TAB_LIST = ['general', 'category winner', 'brand winner']

const TAB_CONTENT = {
    general: <GeneralAwardWinnerContainer />,
    'category winner': <CategoryWinnerContainer />,
    'brand winner': <BrandWinnerContainer />,
}

export const AwardWinnerContainer = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const sectionName = searchParams.get('sectionName')

    const onChangeSidebar = (item) => {
        navigate(`/awards/winners?sectionName=${item}`)
    }

    const props = {
        options: AWARD_WINNER_TAB_LIST,
        content: TAB_CONTENT,
        activeSidebar: sectionName || 'general',
        onChangeSidebar,
    }

    return <AwardWinner {...props} />
}
